



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_PENSION_UNIT_SELECTION } from '@/queries/PensionUnitSelection';

@Component
export default class PensionUnitSelectionShow extends Vue {
  private GET_PENSION_UNIT_SELECTION = GET_PENSION_UNIT_SELECTION;
  @Prop(String) private id!: string;
}
